import { apiUrl } from "../../utils/apiUrl";

export async function Post<T>(
  url = "",
  accessToken: string,
  data = {}
): Promise<T> {
  const response = await fetch(apiUrl(url), {
    method: "POST",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data),
  });
  return await response.json();
}

export async function Put<T>(
  url = "",
  accessToken: string,
  data = {}
): Promise<T> {
  const response = await fetch(apiUrl(url), {
    method: "PUT",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: JSON.stringify(data),
  });
  return await response.json();
}

export async function Get<T>(url = "", accessToken: string): Promise<T> {
  // console.log("TOKEN", accessToken)
  const response = await fetch(apiUrl(url), {
    method: "GET",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
  });
  if (response.ok) {
    return await response.json();
  } else {
    return Promise.reject(response);
  }
}

export async function Delete<T>(url = "", accessToken: string): Promise<T> {
  const response = await fetch(apiUrl(url), {
    method: "DELETE",
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
    redirect: "follow",
    referrerPolicy: "no-referrer",
  });
  if (response.ok) {
    return await response.json();
  } else {
    return Promise.reject(response);
  }
}
